import customTranslate from "../modelerTranslate/customTranslate";
function ColorContextPadProvider(contextPad, popupMenu, canvas) {
  this._contextPad = contextPad;
  this._popupMenu = popupMenu;
  this._canvas = canvas;

  contextPad.registerProvider(this);
}

ColorContextPadProvider.$inject = ["contextPad", "popupMenu", "canvas"];
export default ColorContextPadProvider;

ColorContextPadProvider.prototype.getContextPadEntries = function (element) {
  const self = this;

  const actions = {
    "set-color": {
      group: "edit",
      className: "bpmn-icon-color",
      title: customTranslate("Set Color"),
      action: {
        click(event, element) {
          // close any existing popup
          self._popupMenu.close();
          // get start popup draw start position
          const opts = getStartPosition(
            self._canvas,
            self._contextPad,
            element,
          );

          // or fallback to current cursor position
          opts.cursor = {
            x: event.x,
            y: event.y,
          };

          // open color picker submenu popup
          self._popupMenu.open(element, "color-picker", opts);
        },
      },
    },
  };

  return actions;
};

// helpers //////////////////////

function getStartPosition(canvas, contextPad, element) {
  const Y_OFFSET = 5;

  const diagramContainer = canvas.getContainer(),
    pad = contextPad.getPad(element).html;

  const diagramRect = diagramContainer.getBoundingClientRect(),
    padRect = pad.getBoundingClientRect();

  const top = padRect.top - diagramRect.top;
  const left = padRect.left - diagramRect.left;

  const pos = {
    x: left,
    y: top + padRect.height + Y_OFFSET,
  };

  return pos;
}
